import { render, staticRenderFns } from "./sycscqycxqkb.vue?vue&type=template&id=1a7f898a&scoped=true&"
import script from "./sycscqycxqkb.vue?vue&type=script&lang=js&"
export * from "./sycscqycxqkb.vue?vue&type=script&lang=js&"
import style0 from "./sycscqycxqkb.vue?vue&type=style&index=0&id=1a7f898a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f898a",
  null
  
)

export default component.exports